module.exports = __webpack_public_path__ + "static/media/summer-snellings.36de6a61.jpg";